import { IQuickSelectorValue } from "source/app/presentation/Shared/QuickSelector/Value/IQuickSelectorValue";

export function GetQuickSelectorValues<TValue>(
    values: TValue[],
    isGoodValueResolver: (value: TValue) => boolean | undefined
) {
    const result = values.map(
        (element) =>
            ({
                value: element,
                labelAcronym: GetLabelAcronym(element),
                isGoodValue: isGoodValueResolver(element),
            } as IQuickSelectorValue<TValue>)
    );

    return result;
}

export function GetLabelAcronym(text: any) {
    if (typeof text !== "string") {
        return undefined;
    }

    if (text === "one") return "1";
    if (text === "two") return "2";
    if (text === "three") return "3";
    if (text === "four") return "4";
    if (text === "five") return "5";
    if (text === "six") return "6";
    if (text === "seven") return "7";
    if (text === "eight") return "8";
    if (text === "nine") return "9";
    if (text === "ten") return "10";

    var matches = text.match(/\b(\w)/g);
    var acronym = matches?.join("");
    return acronym ?? "";
}
